import React from 'react';
import { ScrollView, View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { Modal } from '@material-ui/core';
import getPlatformType from '../../../../../helpers/helpers';

const HoldingTerms = ({ isVisible, onClose }) => {
    return (
        <Modal
            open={isVisible ? isVisible : false}
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                paddingLeft: 10,
                paddingRight: 10,
                flex: 1,

            }}
        >
            <View style={styles.overlay}>
                <View style={styles.modalContainer}>

                    <View style={styles.card}>
                        <Text style={styles.heading}>Holding Deposit Terms</Text>

                        <Text style={styles.bold}>
                        A holding deposit or “holding fee” is a financial sum that tenant(s) pay as confirmation of their intent to proceed with an application to rent a property. The deposit secures the property for tenant(s).
                        It is payable to the landlord or their letting agent and can legally be no more than one week’s rent. Please note the holding deposit is usually deducted from the "move in monies”.
                        </Text>
                   
                        <Text style={styles.sectionTitle}>Your deposit will be refunded within 7 days if:</Text>

                        <Text style={styles.bullet}>
                        1.The landlord alters the terms and you are no longer in agreement or                        </Text>
                        <Text style={styles.bullet}>
                        2.Your landlord decides not to proceed or
                        </Text>
                        <Text style={styles.bullet}>
                        3.The tenancy has not commenced by the agreed start date or within 15 days of the date of payment of the holding deposit (whichever is the later) and no extension has been agreed, For the avoidance of doubt the start date is noted in the Rental Offer.
                        </Text>
                       
                        <Text style={styles.sectionTitle}>Your deposit will not be refunded if:</Text>
                        {[
                            '1.You decide not to proceed with the tenancy or',
                            '2.You do not take all reasonable steps to proceed with and enter into the tenancy, whilst the',
                            '3.You do not take all reasonable steps to proceed with and enter into the tenancy, whilst the landlord has taken all reasonable steps to proceed with and enter into a tenancy with you or',
                            '4.You provide false or misleading information in respect of your ability to meet referencing criteria (detailed below) or',
                            '5.You fail your Right to Rent checks',
                        ].map((item, i) => (
                            <Text key={i} style={styles.bullet}>{item}</Text>
                        ))}
                         <Text style={styles.sectionTitle}>YIn order to pass the referencing process you will be required to meet the following criteria:</Text>
                        {[
                            '1.Affordability – your share of the rent should not exceed 40% of your annual gross salary',
                            "2.Employment – your employer will be asked to confirm your terms of employment and salary. If you are self-employed you will need to provide evidence of your income such as a tax return or accountants letter",
                            "3.Previous Landlord – if applicable your previous landlord will need to confirm your suitability as a tenant and that there were no breaches of the tenancy such as damages or rent arrears."
                        ].map((item, i) => (
                            <Text key={i} style={styles.bullet}>{item}</Text>
                        ))}
                    </View>
                    <View style={styles.actions}>
                    <TouchableOpacity
                    onPress={onClose}
                    style={styles.buyBtn}>
                    <Text style={styles.buyText}>Ok</Text>
              
                </TouchableOpacity>
                </View>
                </View>
               
            </View>
   
        </Modal>

    );
};
const layoutType = getPlatformType()
const styles = StyleSheet.create({
    actions: {
        flexDirection: 'row',
        justifyContent: 'center',
    },
    buyBtn: {
        backgroundColor: '#6b21a8',
        paddingVertical: 10,
        paddingHorizontal: 28,
        borderRadius: 8,
        marginTop:10
    },
    buyText: {
        color: 'white',
        fontWeight: '600',
    },
    overlay: {
        justifyContent: 'center',
        alignItems: 'center',
        width:layoutType=="web"? "70%":"94%"
    },
    modalContainer: {
        backgroundColor: 'white',
        borderRadius: 10,
        shadowColor: '#000',
        shadowOpacity: 0.2,
        shadowRadius: 5,
        elevation: 5,
    },
    container: {
        backgroundColor: '#f8f8f8',
    },
    card: {
        backgroundColor: '#fff',
        padding: 20,
        borderRadius: 12,
        shadowColor: '#000',
        shadowOpacity: 0.08,
        shadowRadius: 8,
        shadowOffset: { width: 0, height: 4 },
        elevation: 3,
        maxHeight: "80vh",
        overflow: "scroll"
    },
    heading: {
        fontSize: 24,
        fontWeight: 'bold',
        textAlign: 'center',
        marginBottom: 20,
    },
    sectionTitle: {
        fontSize: 18,
        fontWeight: 'bold',
        marginTop: 20,
        marginBottom: 10,
        color: '#4B0082',
    },
    subHeading: {
        fontSize: 16,
        fontWeight: '600',
        marginTop: 10,
        marginBottom: 5,
        color: '#6A5ACD',
    },
    bullet: {
        fontSize: 14,
        marginVertical: 4,
        color: '#333',
        lineHeight: 20,
    },
    bold: {
        fontWeight: 'bold',
    },
});

export default HoldingTerms;
